// NGRX
import { createFeatureSelector, createSelector } from '@ngrx/store';
// Lodash
import { each } from 'lodash-es';
// CRUD
import { QueryResultsModel, HttpExtenstionsModel } from '../../_base/crud';
// State
import { PatientWeightsState } from '../_reducers/patient-weight.reducers';
import { PatientWeightModel } from '../_models/patient-weight.model';

export const selectPatientWeightsState =
  createFeatureSelector<PatientWeightsState>('patientWeights');

export const selectPatientWeightById = (patientWeightId: number) =>
  createSelector(
    selectPatientWeightsState,
    (patientWeightsState) => patientWeightsState.entities[patientWeightId],
  );

export const selectPatientWeightsPageLoading = createSelector(
  selectPatientWeightsState,
  (patientWeightsState) => patientWeightsState.listLoading,
);

export const selectPatientWeightsActionLoading = createSelector(
  selectPatientWeightsState,
  (patientWeightsState) => patientWeightsState.actionsloading,
);

export const selectLastCreatedPatientWeightId = createSelector(
  selectPatientWeightsState,
  (patientWeightsState) => patientWeightsState.lastCreatedPatientWeightId,
);

export const selectPatientWeightErrorState = createSelector(
  selectPatientWeightsState,
  (patientWeightsState) => patientWeightsState.error,
);

export const selectPatientWeightsShowInitWaitingMessage = createSelector(
  selectPatientWeightsState,
  (patientWeightsState) => patientWeightsState.showInitWaitingMessage,
);

export const selectPatientWeightsInStore = createSelector(
  selectPatientWeightsState,
  (patientWeightsState) => {
    const items: PatientWeightModel[] = [];
    each(patientWeightsState.entities, (element) => {
      items.push(element);
    });
    const httpExtension = new HttpExtenstionsModel();
    const result: PatientWeightModel[] = httpExtension.sortArray(
      items,
      patientWeightsState.lastQuery.sortField,
      patientWeightsState.lastQuery.sortOrder,
    );
    return new QueryResultsModel(result, patientWeightsState.totalCount);
  },
);
